import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
// import * as storeUtils from '../../../utils/store-handler';
import { EventBus } from "../../../event-bus";
import * as pConsts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
// import consts from '../../../_consts';

export const state = {
  certificates: [],
  certificate: [],
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [pConsts.GETTERS_LIST_PGP_CERTIFICATE]: state => {
    return state.certificates;
  },
  [pConsts.GETTERS_PGPCERTIFICATE]: state => {
    return state.certificate;
  }
};

export const actions = {
  [pConsts.ACTION_GET_PGP_CERTIFICATE_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().employers.getPGPCertificates,
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(pConsts.MUTATION_SET_PGP_CERTIFICATE_LIST, response);
        }
      })
      .catch(function({ response }) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [pConsts.ACTION_GET_PGP_CERTIFICATE_LIST_BY_EMPLOYER]: (
    { commit },
    options
  ) => {
    let url = getEndPoints().employers.getPGPCertificatesByEmployer.replace(
      ":id",
      options.employer_id
    );
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        if (response.data) {
          commit(pConsts.MUTATION_SET_PGP_CERTIFICATE_LIST, response);
        }
      })
      .catch(function({ response }) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [pConsts.ACTION_GET_PGPCERTIFICATE]: ({ commit }, options) => {
    makeCall(
      getEndPoints().employers.getPGPCertificate.replace(
        ":id",
        options.pgpcertificate_id
      ),
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(pConsts.MUTATION_SET_PGPCERTIFICATE, response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [pConsts.ACTION_SET_PGPCERTIFICATE]: ({ commit }, options) => {
    let method = "POST";
    let url = options.isEdit
      ? getEndPoints().employers.getPGPCertificate.replace(
          ":id",
          options.pgpcertificate_id
        )
      : getEndPoints().employers.addPGPCertificate;
    makeCall(
      url,
      buildOptions(method, options.data, {
        headers: { "Content-Type": "multipart/form-data" }
      }),
      commit
    )
      .then(response => {
        if (response.error) {
          if (options.errorHandling) {
            options.errorHandling(response.error);
          }
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [pConsts.ACTION_DELETE_PGP_CERTIFICATE]: ({ commit }, options) => {
    let url = getEndPoints().employers.deleteCertificate.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("DELETE", {}), commit)
      .then(response => {
        if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  }
};

export const mutations = {
  [pConsts.MUTATION_SET_PGP_CERTIFICATE_LIST]: (state, certificates) => {
    state.certificates = certificates;
  },
  [pConsts.MUTATION_SET_PGPCERTIFICATE]: (state, filesource) => {
    state.certificate = filesource;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/pgp_certificate/index.js